module.exports = __webpack_public_path__ + "static/media/Esseti.dabaa951.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Esseti.png
// module id = 89
// module chunks = 0